/**
 * INDO SOURCE BALI — Cart & Login System
 * Full cart functionality with localStorage persistence
 */

(function() {
  'use strict';

  // Toast helper
  function showToast(message) {
    var existing = document.querySelector('.toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.style.cssText = 'position:fixed;bottom:24px;right:24px;padding:14px 24px;background:var(--color-dark);color:var(--color-light);font-family:var(--font-label);font-size:12px;text-transform:uppercase;letter-spacing:0.18em;z-index:100000;transform:translateY(100px);opacity:0;transition:all 0.3s ease;';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.style.transform = 'translateY(0)';
      toast.style.opacity = '1';
    });
    setTimeout(function() {
      toast.style.transform = 'translateY(100px)';
      toast.style.opacity = '0';
      setTimeout(function() { toast.remove(); }, 300);
    }, 2500);
  }

  // ==========================================
  // LOGIN STATE
  // ==========================================
  var isLoggedIn = false;
  var currentUser = null;

  function loadLoginState() {
    try {
      var saved = localStorage.getItem('isb_user');
      if (saved) {
        currentUser = JSON.parse(saved);
        isLoggedIn = true;
        updateUIForLogin();
      }
    } catch(e) {}
  }

  function login(email, name) {
    currentUser = { email: email, name: name || 'Trade Buyer', since: Date.now() };
    isLoggedIn = true;
    try { localStorage.setItem('isb_user', JSON.stringify(currentUser)); } catch(e) {}
    updateUIForLogin();
    renderCart();
    showToast('Welcome, ' + currentUser.name + '!');
    closeAllModals();
  }

  function logout() {
    currentUser = null;
    isLoggedIn = false;
    try { localStorage.removeItem('isb_user'); } catch(e) {}
    updateUIForLogout();
    renderCart();
    showToast('You have been logged out.');
  }

  function updateUIForLogin() {
    // Update account button
    var accountBtn = document.querySelector('.header-icon[aria-label="Account"]');
    if (accountBtn && currentUser) {
      accountBtn.setAttribute('aria-label', 'My Account (' + currentUser.name + ')');
      accountBtn.setAttribute('data-logged-in', 'true');
    }
    // Show prices
    document.querySelectorAll('.price-hidden').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.price-visible').forEach(function(el) {
      el.style.display = 'block';
    });
    // Update account modal
    updateAccountModalForLoggedIn();
  }

  function updateUIForLogout() {
    var accountBtn = document.querySelector('.header-icon[aria-label="My Account"]') || 
                     document.querySelector('.header-icon[aria-label="Account"]');
    if (accountBtn) {
      accountBtn.setAttribute('aria-label', 'Account');
      accountBtn.removeAttribute('data-logged-in');
    }
    // Hide prices
    document.querySelectorAll('.price-hidden').forEach(function(el) {
      el.style.display = 'flex';
    });
    document.querySelectorAll('.price-visible').forEach(function(el) {
      el.style.display = 'none';
    });
    updateAccountModalForLoggedOut();
  }

  function updateAccountModalForLoggedIn() {
    var modal = document.getElementById('accountModal');
    if (!modal || !currentUser) return;
    var content = modal.querySelector('.modal-content');
    if (!content) return;
    content.innerHTML = 
      '<button class="modal-close" data-modal-close aria-label="Close account">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<h3 class="font-display" style="font-size:22px;margin-bottom:4px">My Account</h3>' +
      '<p style="font-size:14px;color:var(--color-warm-gray);margin-bottom:24px">' + currentUser.email + '</p>' +
      '<div style="display:flex;flex-direction:column;gap:12px;margin-bottom:24px">' +
        '<div style="padding:12px;background:var(--color-parchment-dark);border:1px solid var(--color-secondary-tone)">' +
          '<div class="font-label" style="font-size:10px;margin-bottom:4px">Account Type</div>' +
          '<div style="font-size:14px">Trade Buyer</div>' +
        '</div>' +
        '<div style="padding:12px;background:var(--color-parchment-dark);border:1px solid var(--color-secondary-tone)">' +
          '<div class="font-label" style="font-size:10px;margin-bottom:4px">Member Since</div>' +
          '<div style="font-size:14px">' + new Date(currentUser.since).toLocaleDateString() + '</div>' +
        '</div>' +
      '</div>' +
      '<a href="checkout.html" class="btn btn-primary" style="width:100%;margin-bottom:12px">View My Orders</a>' +
      '<button class="btn btn-secondary" style="width:100%" id="logoutBtn">Logout</button>';
    
    // Re-attach logout listener
    var logoutBtn = document.getElementById('logoutBtn');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', logout);
    }
    // Re-attach close listeners
    content.querySelectorAll('[data-modal-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var m = this.closest('.modal-overlay');
        if (m) { m.classList.remove('active'); document.body.style.overflow = ''; }
      });
    });
  }

  function updateAccountModalForLoggedOut() {
    var modal = document.getElementById('accountModal');
    if (!modal) return;
    var content = modal.querySelector('.modal-content');
    if (!content) return;
    content.innerHTML = 
      '<button class="modal-close" data-modal-close aria-label="Close account">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<h3 class="font-display" style="font-size:22px;margin-bottom:8px">Trade Account</h3>' +
      '<p style="font-size:14px;color:var(--color-warm-gray);margin-bottom:28px">Sign in to view pricing, access wholesale catalog, and manage orders.</p>' +
      '<form id="loginForm" style="display:flex;flex-direction:column;gap:20px">' +
        '<div>' +
          '<label class="form-label">Email</label>' +
          '<input type="email" class="form-input" id="loginEmail" placeholder="your@email.com" required>' +
        '</div>' +
        '<div>' +
          '<label class="form-label">Password</label>' +
          '<input type="password" class="form-input" placeholder="••••••••">' +
        '</div>' +
        '<button type="submit" class="btn btn-primary" style="width:100%">Sign In</button>' +
        '<p style="text-align:center;font-size:13px;color:var(--color-warm-gray);margin:0">Don\'t have an account? <a href="contact.html" style="color:var(--color-primary)">Apply for Wholesale</a></p>' +
      '</form>';
    
    var form = document.getElementById('loginForm');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = document.getElementById('loginEmail').value;
        login(email);
      });
    }
    content.querySelectorAll('[data-modal-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var m = this.closest('.modal-overlay');
        if (m) { m.classList.remove('active'); document.body.style.overflow = ''; }
      });
    });
  }

  // ==========================================
  // CART SYSTEM
  // ==========================================
  var cart = [];

  function loadCart() {
    try {
      var saved = localStorage.getItem('isb_cart');
      if (saved) cart = JSON.parse(saved);
    } catch(e) { cart = []; }
    updateCartBadge();
  }

  function saveCart() {
    try { localStorage.setItem('isb_cart', JSON.stringify(cart)); } catch(e) {}
    updateCartBadge();
  }

  function updateCartBadge() {
    var totalQty = cart.reduce(function(sum, item) { return sum + item.qty; }, 0);
    var badge = document.querySelector('.cart-count');
    if (badge) {
      badge.textContent = totalQty;
      badge.style.display = totalQty > 0 ? 'flex' : 'none';
    }
  }

  function addToCart(product) {
    var existing = cart.find(function(item) { return item.id === product.id; });
    if (existing) {
      existing.qty += product.qty || 1;
    } else {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price || 0,
        image: product.image,
        category: product.category,
        qty: product.qty || 1,
        added: Date.now()
      });
    }
    saveCart();
    renderCart();
    showToast(product.name + ' added to cart');
  }

  function removeFromCart(id) {
    cart = cart.filter(function(item) { return item.id !== id; });
    saveCart();
    renderCart();
  }

  function updateCartQty(id, qty) {
    var item = cart.find(function(item) { return item.id === id; });
    if (item) {
      if (qty <= 0) {
        removeFromCart(id);
      } else {
        item.qty = qty;
        saveCart();
        renderCart();
      }
    }
  }

  function getCartTotal() {
    return cart.reduce(function(sum, item) { return sum + (item.price * item.qty); }, 0);
  }

  function renderCart() {
    var body = document.querySelector('.cart-sidebar-body');
    var footer = document.querySelector('.cart-sidebar-footer');
    if (!body || !footer) return;

    if (cart.length === 0) {
      body.innerHTML = 
        '<div class="cart-empty" style="text-align:center;padding:60px 24px">' +
          '<svg viewBox="0 0 24 24" fill="none" style="width:48px;height:48px;stroke:var(--color-secondary-tone);stroke-width:1;margin:0 auto 16px;display:block"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '<p style="font-size:16px;margin-bottom:8px;color:var(--color-dark)">Your cart is empty</p>' +
          '<p style="font-size:13px;margin:0;color:var(--color-warm-gray)">Browse our collection to find handcrafted pieces.</p>' +
        '</div>';
      footer.innerHTML = '<a href="shop.html" class="btn btn-primary" style="width:100%">Start Shopping</a>';
    } else {
      var html = '<div style="display:flex;flex-direction:column;gap:0">';
      cart.forEach(function(item) {
        html += 
          '<div style="display:flex;gap:12px;padding:16px 0;border-bottom:1px solid var(--color-secondary-tone)">' +
            '<div style="width:64px;height:80px;flex-shrink:0;overflow:hidden">' +
              '<img src="' + item.image + '" alt="' + item.name + '" style="width:100%;height:100%;object-fit:cover">' +
            '</div>' +
            '<div style="flex:1;min-width:0">' +
              '<div style="font-size:13px;color:var(--color-warm-gray);margin-bottom:2px">' + (item.category || '') + '</div>' +
              '<div style="font-size:14px;font-weight:500;color:var(--color-dark);margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + item.name + '</div>' +
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px">' +
                '<div class="product-card-qty" style="height:28px">' +
                  '<button type="button" data-cart-dec="' + item.id + '" style="width:24px;height:28px;font-size:14px">-</button>' +
                  '<input type="text" value="' + item.qty + '" readonly style="width:28px;height:28px;font-size:12px">' +
                  '<button type="button" data-cart-inc="' + item.id + '" style="width:24px;height:28px;font-size:14px">+</button>' +
                '</div>' +
                '<button data-cart-remove="' + item.id + '" style="background:none;border:none;color:var(--color-warm-gray);font-size:12px;cursor:pointer;text-decoration:underline">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      html += '</div>';
      
      // Show prices only if logged in
      if (isLoggedIn) {
        var total = getCartTotal();
        html += '<div style="padding:16px 0;border-top:2px solid var(--color-dark);margin-top:8px">' +
          '<div style="display:flex;justify-content:space-between;font-size:16px;font-weight:600">' +
            '<span>Subtotal</span><span>$' + total.toFixed(2) + '</span>' +
          '</div>' +
          '<p style="font-size:12px;color:var(--color-warm-gray);margin-top:4px">Shipping calculated at checkout</p>' +
        '</div>';
        footer.innerHTML = 
          '<a href="checkout.html" class="btn btn-primary" style="width:100%;margin-bottom:8px">Proceed to Checkout</a>' +
          '<button class="btn btn-secondary btn-small" data-cart-clear style="width:100%;font-size:11px;padding:10px">Clear Cart</button>';
      } else {
        html += '<div style="padding:16px;background:var(--color-parchment-dark);margin-top:12px;border:1px solid var(--color-secondary-tone)">' +
          '<p style="font-size:13px;color:var(--color-warm-gray);margin:0;text-align:center">Login to view pricing and proceed to checkout</p>' +
        '</div>';
        footer.innerHTML = 
          '<button class="btn btn-primary" style="width:100%;margin-bottom:8px" id="cartLoginBtn">Login to Checkout</button>' +
          '<button class="btn btn-secondary btn-small" data-cart-clear style="width:100%;font-size:11px;padding:10px">Clear Cart</button>';
        
        var loginBtn = document.getElementById('cartLoginBtn');
        if (loginBtn) {
          loginBtn.addEventListener('click', function() {
            closeAllModals();
            var modal = document.getElementById('accountModal');
            if (modal) {
              modal.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          });
        }
      }
      
      body.innerHTML = html;
      
      // Attach event listeners
      body.querySelectorAll('[data-cart-dec]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.dataset.cartDec;
          var item = cart.find(function(i) { return i.id === id; });
          if (item) updateCartQty(id, item.qty - 1);
        });
      });
      body.querySelectorAll('[data-cart-inc]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.dataset.cartInc;
          var item = cart.find(function(i) { return i.id === id; });
          if (item) updateCartQty(id, item.qty + 1);
        });
      });
      body.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeFromCart(this.dataset.cartRemove);
        });
      });
      var clearBtn = footer.querySelector('[data-cart-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          cart = [];
          saveCart();
          renderCart();
          showToast('Cart cleared');
        });
      }
    }
  }

  function closeAllModals() {
    document.querySelectorAll('.modal-overlay.active').forEach(function(m) {
      m.classList.remove('active');
    });
    var cartSidebar = document.getElementById('cartSidebar');
    if (cartSidebar) cartSidebar.classList.remove('active');
    document.body.style.overflow = '';
  }

  // ==========================================
  // INIT
  // ==========================================
  document.addEventListener('DOMContentLoaded', function() {
    loadCart();
    loadLoginState();

    // Login form handler
    var loginForm = document.getElementById('loginForm');
    if (loginForm) {
      loginForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = document.getElementById('loginEmail').value;
        var name = email.split('@')[0];
        login(email, name.charAt(0).toUpperCase() + name.slice(1));
      });
    }

    // Cart trigger
    var cartTrigger = document.getElementById('cartTrigger');
    if (cartTrigger) {
      cartTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        var sidebar = document.getElementById('cartSidebar');
        if (sidebar) {
          sidebar.classList.add('active');
          document.body.style.overflow = 'hidden';
          renderCart();
        }
      });
    }

    // Cart close
    document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var sidebar = document.getElementById('cartSidebar');
        if (sidebar) sidebar.classList.remove('active');
        document.body.style.overflow = '';
      });
    });

    // Close modals
    document.querySelectorAll('[data-modal-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var modal = this.closest('.modal-overlay');
        if (modal) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });

    // Close on click outside
    document.querySelectorAll('.modal-overlay').forEach(function(modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === this) {
          this.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });
  });

  // Expose globals for inline handlers
  window.ISB = {
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    updateCartQty: updateCartQty,
    getCart: function() { return cart; },
    getCartTotal: getCartTotal,
    login: login,
    logout: logout,
    isLoggedIn: function() { return isLoggedIn; },
    renderCart: renderCart,
    user: function() { return currentUser; }
  };

})();


/**
 * INDO SOURCE BALI — Main JavaScript
 * Minimal vanilla JS for interactions
 */

document.addEventListener('DOMContentLoaded', function () {

  // ==========================================
  // Sticky Header
  // ==========================================
  const header = document.querySelector('.site-header');
  let lastScrollY = 0;

  function updateHeader() {
    const scrollY = window.scrollY;

    if (scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  // ==========================================
  // Mobile Menu Toggle
  // ==========================================
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('active');
      document.body.style.overflow = mobileNav.classList.contains('active') ? 'hidden' : '';

      // Animate hamburger
      const spans = menuToggle.querySelectorAll('span');
      if (mobileNav.classList.contains('active')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '1';
        spans[2].style.transform = '';
      }
    });

    // Close mobile nav on link click
    mobileNavLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('active');
        document.body.style.overflow = '';
        const spans = menuToggle.querySelectorAll('span');
        spans[0].style.transform = '';
        spans[1].style.opacity = '1';
        spans[2].style.transform = '';
      });
    });
  }

  // ==========================================
  // Mobile Dropdown Toggle
  // ==========================================
  var mobileDropdowns = document.querySelectorAll('.mobile-dropdown');

  mobileDropdowns.forEach(function (dropdown) {
    var toggle = dropdown.querySelector('.mobile-dropdown-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        dropdown.classList.toggle('open');
        var isOpen = dropdown.classList.contains('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  });

  // ==========================================
  // FAQ Accordion
  // ==========================================
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach(function (item) {
    const header = item.querySelector('.accordion-header');

    header.addEventListener('click', function () {
      const isActive = item.classList.contains('active');

      // Close all items (only one open at a time)
      accordionItems.forEach(function (otherItem) {
        otherItem.classList.remove('active');
        const body = otherItem.querySelector('.accordion-body');
        if (body) body.style.maxHeight = null;
      });

      // Toggle current item
      if (!isActive) {
        item.classList.add('active');
        const body = item.querySelector('.accordion-body');
        if (body) {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      }
    });
  });

  // ==========================================
  // Tab Switching
  // ==========================================
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const tabId = this.dataset.tab;

      // Update buttons
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      // Update panels
      tabPanels.forEach(function (panel) {
        panel.classList.remove('active');
        if (panel.dataset.panel === tabId) {
          panel.classList.add('active');
        }
      });
    });
  });

  // ==========================================
  // Product Image Gallery
  // ==========================================
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const galleryMain = document.querySelector('.gallery-main-image');

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = this.dataset.src;

      // Update main image
      if (galleryMain) {
        galleryMain.style.opacity = '0';
        setTimeout(function () {
          galleryMain.src = src;
          galleryMain.style.opacity = '1';
        }, 200);
      }

      // Update active state
      galleryThumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ==========================================
  // Cart Counter
  // ==========================================
  let cartCount = 0;
  const cartCountEl = document.querySelector('.cart-count');
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  function updateCartCount() {
    if (cartCountEl) {
      cartCountEl.textContent = cartCount;
      cartCountEl.style.display = cartCount > 0 ? 'flex' : 'none';
    }
  }

  addToCartBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const qty = parseInt(this.dataset.qty || '1');
      cartCount += qty;
      updateCartCount();

      // Show toast
      showToast('Added to cart');

      // Button feedback
      const originalText = this.textContent;
      this.textContent = 'Added!';
      setTimeout(() => {
        this.textContent = originalText;
      }, 1200);
    });
  });

  // Initialize cart count
  updateCartCount();

  // ==========================================
  // Toast Notification
  // ==========================================
  function showToast(message) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');

    setTimeout(function () {
      toast.classList.remove('show');
    }, 2500);
  }

  // ==========================================
  // Quantity Selector
  // ==========================================
  const qtyBtns = document.querySelectorAll('.quantity-btn');

  qtyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.quantity-input');
      let val = parseInt(input.value) || 1;

      if (this.dataset.action === 'dec' && val > 1) {
        val--;
      } else if (this.dataset.action === 'inc') {
        val++;
      }

      input.value = val;
    });
  });

  // ==========================================
  // Filter Chips (Shop Page)
  // ==========================================
  const filterChips = document.querySelectorAll('.filter-chip');

  filterChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      filterChips.forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ==========================================
  // Smooth Scroll for Anchor Links
  // ==========================================
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // ==========================================
  // Header color based on section (optional)
  // ==========================================
  const sections = document.querySelectorAll('[data-header-color]');

  if (sections.length > 0) {
    const observerOptions = {
      rootMargin: '-64px 0px 0px 0px',
      threshold: 0
    };

    const sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const color = entry.target.dataset.headerColor;
          header.classList.remove('on-sand', 'on-umber', 'on-parchment');
          if (color) {
            header.classList.add('on-' + color);
          }
        }
      });
    }, observerOptions);

    sections.forEach(function (section) {
      sectionObserver.observe(section);
    });
  }

  // ==========================================
  // Scroll Reveal Animation
  // ==========================================
  const revealElements = document.querySelectorAll('[data-reveal]');

  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  // ==========================================
  // Newsletter Form
  // ==========================================
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      if (input && input.value) {
        showToast('Thank you for subscribing!');
        input.value = '';
      }
    });
  }

  // ==========================================
  // Contact Form
  // ==========================================
  const contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      showToast('Message sent! We will be in touch soon.');
      this.reset();
    });
  }

  // ==========================================
  // Trade / Wholesale Form
  // ==========================================
  const tradeForm = document.querySelector('.trade-form');
  if (tradeForm) {
    tradeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      showToast('Quote request submitted! Our team will contact you within 24 hours.');
      this.reset();
    });
  }

  // ==========================================
  // Hero Slideshow (Modern Living / Shop by Mood)
  // ==========================================
  var heroSlides = document.querySelectorAll('.hero-slide');
  var slideDots = document.querySelectorAll('.slide-dot');
  var currentHeroSlide = 0;
  var heroSlideCount = heroSlides.length;
  var heroAutoTimer;

  function goToHeroSlide(index) {
    if (heroSlideCount <= 1) return;
    if (index < 0) index = heroSlideCount - 1;
    if (index >= heroSlideCount) index = 0;
    currentHeroSlide = index;

    heroSlides.forEach(function(slide, i) {
      if (i === currentHeroSlide) {
        slide.classList.add('active');
        slide.style.opacity = '1';
        slide.style.zIndex = '2';
      } else {
        slide.classList.remove('active');
        slide.style.opacity = '0';
        slide.style.zIndex = '1';
      }
    });

    slideDots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === currentHeroSlide);
      dot.style.background = i === currentHeroSlide ? 'var(--color-dark)' : 'transparent';
    });
  }

  function nextHeroSlide() {
    goToHeroSlide(currentHeroSlide + 1);
  }

  function startHeroAutoPlay() {
    if (heroAutoTimer) clearInterval(heroAutoTimer);
    heroAutoTimer = setInterval(nextHeroSlide, 6000);
  }

  if (heroSlideCount > 1) {
    // Dot click handlers
    slideDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(this.dataset.slide);
        goToHeroSlide(idx);
        startHeroAutoPlay(); // reset timer
      });
    });
    startHeroAutoPlay();
  }

  // ==========================================
  // Promo Banner Carousel
  // ==========================================
  var carouselInner = document.querySelector('.carousel-inner');
  var carouselBtns = document.querySelectorAll('.carousel-btn');
  var currentSlide = 0;
  var slideCount = 4;
  var autoPlayTimer;

  function goToSlide(index) {
    if (index < 0) index = slideCount - 1;
    if (index >= slideCount) index = 0;
    currentSlide = index;
    if (carouselInner) {
      carouselInner.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    }
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function startAutoPlay() {
    autoPlayTimer = setInterval(nextSlide, 5000);
  }

  function stopAutoPlay() {
    clearInterval(autoPlayTimer);
  }

  if (carouselInner) {
    carouselBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        stopAutoPlay();
        if (this.dataset.carousel === 'prev') {
          goToSlide(currentSlide - 1);
        } else {
          goToSlide(currentSlide + 1);
        }
        startAutoPlay();
      });
    });
    startAutoPlay();
  }

  // ==========================================
  // Product Card Quantity Buttons
  // ==========================================
  var qtyContainers = document.querySelectorAll('[data-card-qty]');

  qtyContainers.forEach(function (container) {
    var input = container.querySelector('input');
    var decBtn = container.querySelector('[data-qty-dec]');
    var incBtn = container.querySelector('[data-qty-inc]');
    var minVal = parseInt(input.value) || 1;

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        var val = parseInt(input.value) || minVal;
        if (val > minVal) {
          input.value = val - 1;
        }
      });
    }

    if (incBtn) {
      incBtn.addEventListener('click', function () {
        var val = parseInt(input.value) || minVal;
        input.value = val + 1;
      });
    }
  });

  // ==========================================
  // Cart Session via localStorage
  // ==========================================
  function saveCartToStorage() {
    try {
      localStorage.setItem('isb_cart_count', cartCount.toString());
    } catch (e) { }
  }

  function loadCartFromStorage() {
    try {
      var stored = localStorage.getItem('isb_cart_count');
      if (stored) {
        cartCount = parseInt(stored) || 0;
        updateCartCount();
      }
    } catch (e) { }
  }

  // Save product view history
  function saveProductView(productName) {
    try {
      var history = JSON.parse(localStorage.getItem('isb_product_history') || '[]');
      history.unshift({ name: productName, time: Date.now() });
      if (history.length > 10) history = history.slice(0, 10);
      localStorage.setItem('isb_product_history', JSON.stringify(history));
    } catch (e) { }
  }

  // Track product link clicks
  document.querySelectorAll('.product-card-title a, .product-card-image a').forEach(function (link) {
    link.addEventListener('click', function () {
      var title = this.textContent.trim();
      if (title) saveProductView(title);
    });
  });

  // Override add to cart to save to storage
  var origUpdateCartCount = updateCartCount;
  updateCartCount = function () {
    origUpdateCartCount();
    saveCartToStorage();
  };

  // Load cart on init
  loadCartFromStorage();

  // ==========================================
  // Custom Upload Zone Click
  // ==========================================
  var uploadZones = document.querySelectorAll('.custom-upload-zone');
  uploadZones.forEach(function (zone) {
    zone.addEventListener('click', function () {
      var fileInput = this.querySelector('input[type="file"]');
      if (fileInput) fileInput.click();
    });
  });

  console.log('Indo Source Bali — JavaScript initialized');
});

// ==========================================
// Modal Handlers — Search, Account, Cart
// ==========================================

// Search Modal
var searchModal = document.getElementById('searchModal');
var searchBtn = document.querySelector('.header-icon[aria-label="Search"]');
var searchCloseBtns = document.querySelectorAll('#searchModal .modal-close');

if (searchBtn && searchModal) {
  searchBtn.addEventListener('click', function(e) {
    e.preventDefault();
    searchModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    var input = searchModal.querySelector('input');
    if (input) setTimeout(function() { input.focus(); }, 100);
  });
}

if (searchModal) {
  searchModal.addEventListener('click', function(e) {
    if (e.target === searchModal) {
      searchModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
}

// Account Modal
var accountModal = document.getElementById('accountModal');
var accountBtn = document.querySelector('.header-icon[aria-label="Account"]');

if (accountBtn && accountModal) {
  accountBtn.addEventListener('click', function(e) {
    e.preventDefault();
    accountModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
}

if (accountModal) {
  accountModal.addEventListener('click', function(e) {
    if (e.target === accountModal) {
      accountModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
}

// Cart Sidebar
var cartSidebar = document.getElementById('cartSidebar');
var cartBtn = document.querySelector('.header-icon[aria-label="Cart"]');
var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

if (cartBtn && cartSidebar) {
  cartBtn.addEventListener('click', function(e) {
    e.preventDefault();
    cartSidebar.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
}

cartCloseBtns.forEach(function(btn) {
  btn.addEventListener('click', function() {
    cartSidebar.classList.remove('active');
    document.body.style.overflow = '';
  });
});

// Close modal buttons (X)
document.querySelectorAll('[data-modal-close]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var modal = this.closest('.modal-overlay');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
});

// Close on Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.modal-overlay.active').forEach(function(m) {
      m.classList.remove('active');
    });
    if (cartSidebar) cartSidebar.classList.remove('active');
    document.body.style.overflow = '';
  }
});

const siteHeader = document.getElementById('siteHeader');

function toggleHeaderScroll() {
  if (window.scrollY > 20) {
    siteHeader.classList.add('scrolled');
  } else {
    siteHeader.classList.remove('scrolled');
  }
}

window.addEventListener('scroll', toggleHeaderScroll);
window.addEventListener('load', toggleHeaderScroll);



